<template>
  <div class="pa-4">
    <h4 class="mb-n1">欢迎, <span class="font-weight-regular">{{ user ? user.email : 'Guest' }}</span></h4>
    <p class="text-caption"></p>
    <v-divider></v-divider>
    <v-scrollbar style="height: calc(100vh - 300px); max-height: 515px">
      <v-list>
        <v-list-item @click="account" color="secondary" rounded>
          <v-icon slot="prepend" class="mr-2">mdi-cog</v-icon>
          <v-list-item-title class="text-subtitle-2"> 帐户设置</v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout" color="secondary" rounded>
          <v-icon slot="prepend" class="mr-2">mdi-logout</v-icon>
          <v-list-item-title class="text-subtitle-2"> 退出</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-scrollbar>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from '@/axios';
import { jwtDecode } from 'jwt-decode';

export default {
  name: 'ks-User-Profile',
  data () {
    return {
      swt1: true,
      swt2: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    ...mapActions('account', ['account']),
    async logout () {
      // 销毁地图实例
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
      // 清除前端会话状态（含 selectedArea / auth 缓存 / jwt）
      this.$store.dispatch('logout');
      // 清除 axios 默认请求头中的 Authorization
      delete axios.defaults.headers.common.Authorization;
      // Wait for next tick to ensure component cleanup is complete
      await this.$nextTick();
      // 跳转到登录页
      this.$router.push('/login');
    }
  },
  mounted () {
    // Check and restore user session if JWT exists
    const jwt = localStorage.getItem('jwt');
    console.log('JWT:', jwt);
    if (jwt && !this.user) {
      const decoded = jwtDecode(jwt);
      console.log('JWT decoded:', decoded);
      if (decoded.exp * 1000 > Date.now()) {
        this.$store.commit('setUser', decoded);
      }
    }
  }
};
</script>

<style scoped>
.rounded-height {
  border-radius: 25px;
  /* 圆角 */
  height: 40px;
  /* 减少高度 */
}
</style>
